<template>
  <div class="invoice-header">
    <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <div class="invoice-list list">
          <div class="invoice-list-header list-header">
            <ul>
              <li>{{$_('invoice_credit_number')}}</li>
              <li>{{$_('invoice_date')}}</li>
              <li>{{$_('deadline')}}</li>
              <li>{{$_('payment_choice')}}</li>
              <li>{{$_('ht_amount')}}</li>
              <li>{{$_('ttc_amount')}}</li>
              <li>PDF</li>
            </ul>
          </div>
          <div class="invoice-list-body list-body" v-if="items.length > 0">
            <div v-for="(item, index) in items" :key="index">
              <InvoiceLine :dataline="item" :index="index" />
            </div>
          </div>
          <div v-else>
            <div class="stock-list-footer no-result">
              <span>{{$_('no_result')}}</span>
            </div>
          </div>
          <div class="invoice-list-footer">
            <Pagination
              :nNumeroPage="pagination_info.nNumeroPage"
              :nNombreElementParPage="pagination_info.nNombreElementParPage"
              :nNbElementTotal="pagination_info.nNbRecordData"
              :sTypeElement="$_('invoices')"
              :fn="loadInvoice"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceLine from "@/modules/facture/components/InvoiceLine";
import Pagination from "@/common/components/widget/Pagination/Pagination";

import invoiceService from "@/modules/facture/services/invoiceService";

export default {
  name: "InvoiceList",
  components: {
    InvoiceLine,
    Pagination
  },
  data() {
    return {
      items: [],
      pagination_info: {
        nNumeroPage: 1,
        nNombreElementParPage: 20,
        nNbRecordData: 0
      }
    };
  },
  created() {
    this.loadInvoice();
  },
  computed: {
    getResearch() {
      return this.$store.getters["facture/get_research"];
    }
  },
  watch: {
    getResearch(val) {
      if (val) {
        this.loadInvoice();
      }
    }
  },
  methods: {
    loadInvoice(nNumeroPage, nNombreElementParPage) {
      let poffset = 0;

      if (nNumeroPage > 0) {
        poffset = nNumeroPage * nNombreElementParPage;
      }

      let fncde = '';
    
      if(this.$route.query.order_id !== undefined && this.$route.query.order_id !== '' ) {
        fncde = this.$route.query.order_id;
      } else {
        fncde = this.$store.getters['facture/get_fncde'] !== '' ? this.$store.getters['facture/get_fncde'] : null;
      }

      if (this.$store.getters["facture/get_reset_invoice_list"]) {
        this.items = Array();
      }

      return invoiceService
        .getInvoiceList({
          fncde,
          fnfact:
            this.$store.getters["facture/get_tnfac"] != ""
              ? this.$store.getters["facture/get_tnfac"]
              : null,
          fdate_fact:
            this.$store.getters["facture/get_fdate_fact"] != ""
              ? this.$store.getters["facture/get_fdate_fact"]
              : null,
          plimit: this.pagination_info.nNombreElementParPage,
          poffset
        })
        .then(res => {

          if(res.data !== null) {
            this.pagination_info.nNbRecordData = res.data.NB_RECORD;
  
            if (res.data.DS_O !== undefined) {
              res.data.DS_O.OUT.map(obj => {
                this.items.push(obj);
              });
            }
          }


          this.$store.dispatch("facture/SELECT", {
            key: "reset_invoice_list",
            value: false
          });
          this.$store.dispatch("facture/SELECT", {
            key: "launch",
            value: false
          });

          return this.pagination_info;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.invoice-list {
  padding: 30px 0px;
}
.invoice-list-header ul {
  display: flex;
}
.invoice-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 7);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.invoice-list-header {
  padding: 15px 0px;
}
.invoice-list-footer {
  padding: 20px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
</style>